<div class="state_page_banner videoBannerGlobal" *ngIf="result.name">
    <video *ngIf="result.video != null" #videoElement width="100%" id="main-video" class="video-playing embed-responsive-item" loop muted autoplay playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true" [poster]="image_url+result.image">
      <source id="source_mp4" [src]="image_url+result.video" type="video/mp4" *ngIf="result.video != null">
  </video>
    <img *ngIf="result.video == null" id="cover_image_url" src="assets/images/largeloading.gif"
    [attr.data-src]="(result?.image == '') ? 'assets/images/Alaska.jpg' : image_url+result?.image" alt="{{result.alt_text_image}}"
    class="lazyload">
    <!-- <h1 class="d-none">{{result?.h1_tag}}</h1> -->
    <h1 class="state_page_banner_name">{{ result?.name }}</h1>
    <div class="state_page_banner_btn">
        <a href="javascript:void(0);" (click)="viewAllExperience(slug)">VIEW ALL {{ result?.name }} EXPERIENCES</a>
    </div>
</div>
<div class="map-section">
    <div class="container">
        <h2 class="explore_div_heading">EXPLORE {{ result?.name }}</h2>
        <!-- --- show desktop -->
        <div class="explore_div_content d-none d-md-block">
            <div class="row">
                <div class="col-6">
                    <ul class="explore_div_list" *ngIf="sub_categories.length > 0">
                        <li *ngFor="let record of sub_categories;let i = index">
                            <a [routerLink]="'/location-region/'+slug+'/'+record.slug" (mouseover)="openWindow(record.id,i)" (mouseout)="closeWindow(record.id,i)">{{ record.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-6">
                    <ul class="explore_div_list right" *ngIf="sub_categories_arr.length > 0">
                        <li *ngFor="let record of sub_categories_arr;let j = index">
                            <a [routerLink]="'/location-region/'+slug+'/'+record.slug" (mouseover)="openWindow(record.id,sub_categories.length+j)" (mouseout)="closeWindow(record.id,sub_categories.length+j)">{{ record.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="explore_div_map_holder" *ngIf="isBrowser">
                <div class="explore_div_map exploreNewMap" id="map_canvas">
                    <google-map [center]="{ lat: lat, lng: lng}" [zoom]="map_zoom">
                        <map-marker *ngFor="let marker of markers; let i = index" [icon]="marker.url" [position]="{lat: +marker.lat,lng: +marker.lng}"></map-marker>
                    </google-map>
                </div>
            </div>
        </div>

        <!-- -- show mobile  -->
        <div class="explore_div_content d-md-none">
            <div class="row">
                <div class="col-6">
                    <ul class="explore_div_list" *ngIf="sub_categories.length > 0">
                        <li *ngFor="let record of sub_categories;let i = index">
                            <a [routerLink]="'/location-region/'+slug+'/'+record.slug">{{ record.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-6">
                    <ul class="explore_div_list right" *ngIf="sub_categories_arr.length > 0">
                        <li *ngFor="let record of sub_categories_arr;let j = index">
                            <a [routerLink]="'/location-region/'+slug+'/'+record.slug">{{ record.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

    </div>
</div>

<div class="location-heading-listing">
    <div class="container">
        <div class="why_state_awesome_conent" *ngIf="result?.location_content?.length > 0 && show_why_is_awesome!=0">
            <h2 class="wsa_heading">WHY {{ result?.name }} IS AWESOME</h2>
            <div class="wsa_list">
                <ul>
                    <ng-container *ngFor="let record of result.location_content">
                        <li *ngIf="record.name && record.description">
                            <div class="wsa_list_item">
                                <div class="wsa_list_image lazyload" [attr.data-bg]="(record?.image == '') ? 'assets/images/DefaultCircle.png' : image_url+record.image" style="background-image:url('../../../../assets/images/loading.gif')">

                                </div>
                                <div class="wsa_list_right">
                                    <h3 class="wsa_list_head">{{ record.name }}</h3>
                                    <div class="map-desc">
                                        <p [innerHTML]="record.description | appendDollar" class="font-17"></p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="explore_top" *ngIf="topTenCategories.length > 0">
    <div class="container">
        <h2 class="explore_top_head">Top 10 Things To Experience in {{ result?.name }}</h2>
        <owl-carousel-o [options]="exploreOwl">
            <ng-template carouselSlide *ngFor="let record of topTenCategories" [id]="record.id">
                <div class="item">
                    <a href="javascript:void(0);" role="button" routerLink="/top-ten-category/{{record.slug}}" (click)="navigateToTopTenCategory($event,record.slug, 'top_ten_category')">
                        <div class="top_slider_item">
                            <div class="lazyload top_slider_wall" style="background-image: url('../../../assets/images/loading.gif');" [attr.data-bg]="(record?.image == '') ? 'assets/images/option_img.png' : image_url_category+record.image">
                                <img src="assets/images/loading.gif" [attr.data-src]="(record?.image == '') ? 'assets/images/option_img.png' : image_url_category+record.image">
                            </div>
                            <div class="top_slider_name">{{ record.name }}</div>
                        </div>
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>

<div class="container">
    <div class="why_state_awesome_conent">
        <div class="viewall_exp_btn">
            <a href="javascript:void(0);" (click)="viewAllExperience(slug)">VIEW ALL {{ result?.name }} EXPERIENCES</a>
        </div>
    </div>
</div>